import { forwardRef, ReactNode, HTMLAttributes } from "react";

interface IModalContentProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  children: ReactNode;
  tabIndex?: number;
}

// Forwarding ref to ensure this component can hold a ref
const ModalContent = forwardRef<HTMLDivElement, IModalContentProps>(
  ({ className, children, tabIndex = -1, ...rest }, ref) => {
    return (
      <div
        ref={ref}
        tabIndex={tabIndex}
        className={`modal-content ${className}`}
        {...rest}
      >
        {children}
      </div>
    );
  },
);

export { ModalContent };
